import iocContainer from "ez-ioc";
import { useConst } from "./useConst";
import AnalyticsService from "@local/power-chord-lib/build/src/services/analytics-service";
import { TYPES } from "../lib/init-dependencies";

/** Gets the analytics service for use in a component */
export function useAnalytics(): AnalyticsService {
    return useConst(() => iocContainer.resolve<AnalyticsService>(TYPES.AnalyticsService));
}